
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M23.34 22.94v15.75h-5V22.94M16.34 22.86v-18a3.5 3.5 0 117 0v18zM9.84 6.58v8.08s0 2.73-4.21 2.73-4.22-2.73-4.22-2.73V6.58M5.63 6.58V22.3M3.13 38.69V24.41a2.5 2.5 0 015 0v14.28zM34.34 17.03v5.07M31.84 38.69V24.41a2.5 2.5 0 015 0v14.28z"}}),_c('ellipse',{attrs:{"cx":"34.34","cy":"11.91","rx":"4.25","ry":"5.67","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    